export default "__VITE_ASSET__BSaU2PJO__"